export interface FieldIssueItem {
  field?: string;
  message: string;
}

export function fieldIssuesFromServer(errors: string[] = []): FieldIssueItem[] {
  return errors.map((error) => {
    const match =
      error.match(/^(?<field>[\w.[\]-]+):\s*(?<message>.+)$/) ??
      error.match(/^Field\s+"(?<field>[^"]+)":\s*(?<message>.+)$/i);

    return {
      field: match?.groups?.field,
      message: match?.groups?.message ?? error,
    };
  });
}
